<div class="cover-full pad-no cover-md hidden-xs"
     ng-class="{
        'cover-full_banner-merchant': ctrl.shopDetails.type === ctrl.shopTypesServ.getTypeOmMerchant(),
        'cover-full_banner-shop': ctrl.shopTypesServ.isOrangeShop(ctrl.shopDetails.type)
     }">
    <div class="container">
        <div class="row" ng-if="ctrl.shopTypesServ.isOrangeShop(ctrl.shopDetails.type)">
            <h1 class="header">Magazine Orange</h1>
            <p>Te a&#x219;tept&#259;m &#238;n magazinele Orange cu oferte create special pentru tine</p>
        </div>
        <div class="row" ng-if="ctrl.shopDetails.type === ctrl.shopTypesServ.getTypeOmMerchant()">
            <h1 class="header">Loca&#539;ii partenere Orange Money</h1>
            <p>Ie&#x219;i &#238;n eviden&#539;&#259; pl&#259;tind cu telefonul mobil &#238;n loca&#539;iile
                partenere</p>
        </div>
    </div>
</div>

<div class="container">
    <breadcrumbs breadcrumbs="ctrl.breadcrumbs"></breadcrumbs>
</div>

<div class="container">
    <div class="row">
        <div class="col-md-6">
            <shop-info has-appointment="ctrl.shopHasAppointment"
                       shop-name="ctrl.shopDetails.name"
                       shop-description="ctrl.shopDetails.description"
                       todays-program="ctrl.todaysProgram"
                       directions-url="ctrl.directionsUrl"
                       shop-type="ctrl.shopDetails.type"
                       shop-sub-type="ctrl.shopDetails.subType"
                       sub-type-descr="ctrl.shopDetails.subTypeDescr">
            </shop-info>
        </div>
        <div class="col-md-6">
            <gallery-carousel items="ctrl.shopDetails.galleryUrls"></gallery-carousel>
        </div>
    </div>
</div>

<div class="shop-details-grey-wrap">
    <div class="container">
        <shop-schedule program="ctrl.shopDetails.program"
                       exceptions="ctrl.shopDetails.scheduleExceptions"></shop-schedule>
    </div>
</div>

<div class="container">
    <div class="col-md-4">
        <shop-services service-types="ctrl.shopDetails.serviceTypes" payment-types="ctrl.shopDetails.paymentTypes"
                       money-transfer-options="ctrl.shopDetails.moneyTransferOptions"></shop-services>
    </div>
    <div class="col-md-8" id="appointment-form">
        <create-appointment ng-show="ctrl.shopHasAppointment"></create-appointment>
    </div>
</div>

<offer offers="::ctrl.offers" ng-if="::ctrl.offers"></offer>

<div ng-show="::ctrl.shopDetails.nearbyShops" class="shop-details-grey-wrap">
    <div class="container">
        <nearby-shops items="ctrl.shopDetails.nearbyShops"></nearby-shops>
    </div>
</div>

<div class="container">
    <!-- <shop-highlights></shop-highlights> -->
</div>
